import { api } from '@/api/api';

const mapData = {
  fromApi(schema) {
    return {
      ...schema,
      editing: false,
      white_list: schema.white_list.map((value) => ({ value })),
    };
  },
  toApi(schema) {
    return {
      ...schema,
      data_type: 'str',
      ...(schema.white_list
        ? { white_list: schema.white_list.map((el) => el.value) }
        : {}),
    };
  },
};

export const schema = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setSchemas(state, schemas) {
      state.list = schemas;
    },
    addSchema(state, schema) {
      state.list.push(schema);
    },
  },
  actions: {
    async fetchSchemas({ rootState, commit }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/data_schema_entries/`
      );
      const schemas = data.map(mapData.fromApi);
      commit(
        'setSchemas',
        schemas.sort((a, b) => (a.order_value > b.order_value ? 1 : -1))
      );
      commit('setFetching', false);
    },
    async updateSchema({ rootState, state, commit }, schema) {
      await api.patch(
        `companies/${rootState.company.currentId}/data_schema_entries/${schema.id}/`,
        mapData.toApi(schema)
      );
      commit(
        'setSchemas',
        state.list.map((s) => {
          if (s.id === schema.id) {
            return schema;
          }
          return s;
        })
      );
    },
    updateSchemaOrder({ rootState, commit }, list) {
      list.forEach((schema, index) =>
        api.patch(
          `companies/${rootState.company.currentId}/data_schema_entries/${schema.id}/`,
          {
            order_value: index,
          }
        )
      );
      commit('setSchemas', list);
    },
    async addSchema({ rootState, commit }, schema) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/data_schema_entries/`,
        mapData.toApi(schema)
      );
      commit('addSchema', mapData.fromApi(data));
    },
  },
};
